import { render, staticRenderFns } from "./TipReportScreen.vue?vue&type=template&id=0c23884e&scoped=true"
import script from "./TipReportScreen.vue?vue&type=script&lang=js"
export * from "./TipReportScreen.vue?vue&type=script&lang=js"
import style0 from "./TipReportScreen.vue?vue&type=style&index=0&id=0c23884e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c23884e",
  null
  
)

export default component.exports